import { useEffect } from "react";

const DEFAULT_TITLE = "FISP | Educación, servicios y contenidos de salud";
const DEFAULT_DESCRIPTION =
  "La comunidad de salud más grande de Latinoamérica. FISP combina educación, tecnología e innovación para formar profesionales comprometidos y difundir contenidos de calidad.";
const DEFAULT_ROBOTS = "index,follow,max-image-preview:large";

function toAbsoluteUrl(value) {
  if (!value || typeof window === "undefined") {
    return "";
  }

  try {
    return new URL(value, window.location.origin).toString();
  } catch {
    return "";
  }
}

function ensureMetaTag(attribute, key) {
  const selector = `meta[${attribute}="${key}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }

  return tag;
}

function ensureLinkTag(rel) {
  const selector = `link[rel="${rel}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }

  return tag;
}

function setMetaContent(attribute, key, value) {
  const tag = ensureMetaTag(attribute, key);

  if (value) {
    tag.setAttribute("content", value);
    return;
  }

  tag.removeAttribute("content");
}

export default function usePageMeta(meta) {
  useEffect(() => {
    if (typeof document === "undefined" || meta?.disabled) {
      return;
    }

    const title = meta?.title || DEFAULT_TITLE;
    const description = meta?.description || DEFAULT_DESCRIPTION;
    const type = meta?.type || "website";
    const robots = meta?.robots || DEFAULT_ROBOTS;
    const canonicalUrl = toAbsoluteUrl(meta?.canonical || meta?.path || window.location.pathname);
    const imageUrl = toAbsoluteUrl(meta?.image || "");
    const twitterCard = imageUrl ? "summary_large_image" : "summary";

    document.title = title;

    setMetaContent("name", "description", description);
    setMetaContent("name", "robots", robots);
    setMetaContent("property", "og:title", title);
    setMetaContent("property", "og:description", description);
    setMetaContent("property", "og:type", type);
    setMetaContent("property", "og:site_name", "FISP");
    setMetaContent("property", "og:url", canonicalUrl);
    setMetaContent("property", "og:image", imageUrl);
    setMetaContent("name", "twitter:card", twitterCard);
    setMetaContent("name", "twitter:title", title);
    setMetaContent("name", "twitter:description", description);
    setMetaContent("name", "twitter:image", imageUrl);

    const canonicalTag = ensureLinkTag("canonical");
    if (canonicalUrl) {
      canonicalTag.setAttribute("href", canonicalUrl);
    } else {
      canonicalTag.removeAttribute("href");
    }
  }, [
    meta?.canonical,
    meta?.description,
    meta?.disabled,
    meta?.image,
    meta?.path,
    meta?.robots,
    meta?.title,
    meta?.type,
  ]);
}
